import React, {Component} from 'react';
import {BrowserRouter, Redirect, Route, Switch} from 'react-router-dom';
import { injectIntl } from 'react-intl';
import LoadingScreen from 'react-loading-screen';
import AppIcon from './../../assets/img/appIcon.svg';

import MapScreen from './../map/MapScreen';
import PostcardScreen from './../postCards/PostcardScreen';
import LandPageScreen from './../landPage/LandPage';
import LandPageDesktopScreen from './../landPageDesktop/LandPageDesktop';
import LoginScreen from './../login/LoginScreen';
import HomeScreen from './../home/HomeScreen';
import ReadMoreScreen from './../readMore/ReadMoreScreen';
import EventListScreen from './../eventList/EventListScreen';
import EventDetailsScreen from './../eventDetails/EventDetailsScreen';
import PlacesListScreen from './../placesList/PlacesListScreen';
import PlaceDetailsScreen from './../placeDetails/PlaceDetailsScreen';
import AboutScreen from './../about/AboutScreen';
import SettingsScreen from './../settings/SettingsScreen';
import TermsConditionsScreen from './../termsConditions/TermsConditionsScreen';

import NotFound from './../../components/notFound/NotFound';
import EventResources from './../../resourcers/eventResources';
import AuthResources from './../../resourcers/authResources';
import PlaceResources from './../../resourcers/placeResources';
import CountryResources from './../../resourcers/countryResources';

import Places from './../../assets/json/places';
import Events from './../../assets/json/events';
import Countries from './../../assets/json/countries';

class MainScreen extends Component {

    authResources = new AuthResources();
    eventResources = new EventResources();
    placeResources = new PlaceResources();
    countryResources = new CountryResources();

    debug = false;

    constructor(props) {
        super(props);
        this.intl = this.props.intl;
        this.state = {
            isMobile: false,
            coords: null,
            places: null,
            events: null,
            countries: null,
            contentLoaded: false,
            requestGeolocation: false
        };

        this.getPlaces = this.getPlaces.bind(this);
        this.getEvents = this.getEvents.bind(this);
        this.getMorePlaces = this.getMorePlaces.bind(this);
        this.getPlaceById = this.getPlaceById.bind(this);
        this.getCountries = this.getCountries.bind(this);
        this.useDummyData = this.useDummyData.bind(this);
        this.requestGeolocation = this.requestGeolocation.bind(this);
        this.geoLocationSuccess = this.geoLocationSuccess.bind(this);
        this.geoLocationFailure = this.geoLocationFailure.bind(this);

        document.onreadystatechange = () => {
            if (document.readyState === 'complete'){
                this.setState({
                    contentLoaded: true
                });
            }
        };
    }

    componentWillMount(){
        if(this.debug){
            this.useDummyData();
            this.authResources.setCurrentUser({});
        }else{
            this.getEvents();
            this.getPlaces();
            this.getCountries();
        }
    }

    getCountries() {
        this.countryResources.getCountries(this.intl.locale).then(countries => {
            this.setState({
                countries: countries
            });
        });
    }

    getPlaces() {
        this.placeResources.getPlaces(this.intl.locale).then(places => {

            let placesObj = {
                highlights: []
            }

            places.forEach(place => {
                if(place.pmm_priority){
                    placesObj.highlights.push(place);
                }
                if(!(place.type.key in placesObj)){
                    placesObj[place.type.key] = [];
                }
                placesObj[place.type.key].push(place);
            });

            this.setState({
                places: placesObj
            });
        });
    }

    getEvents() {
        this.eventResources.getEvents(this.intl.locale).then(events => {
            this.setState({
                events: events
            });
        });
    }

    useDummyData() {
        let places = Places;

        let placesObj = {
            highlights: []
        }

        places.forEach(place => {
            if(place.pmm_priority){
                placesObj.highlights.push(place);
            }
            if(!(place.type.key in placesObj)){
                placesObj[place.type.key] = [];
            }
            placesObj[place.type.key].push(place);
        });

        this.setState({
            places: placesObj,
            events: Events,
            countries: Countries
        });
    }

    getMorePlaces(indexes) {
        let places = [];
        let indexesPushed = [];
        let list = this.state.places;

        Object.values(list).forEach(categoryList => {
            for(let i=0; i<categoryList.length; i++){
                if(indexes.includes(parseInt(categoryList[i].id)) &&
                   !indexesPushed.includes(parseInt(categoryList[i].id))){
                    places.push(categoryList[i]);
                    indexesPushed.push(parseInt(categoryList[i].id));
                }
            }
        });

        return places;
    }

    getPlaceList(category) {
        if(this.state.places){
            let list = this.state.places;

            if(category in list){
                let title;

                if(category === "highlights"){
                    title = this.intl.formatMessage({id: "highlight"});
                }else{
                    title = list[category][0].type.text;
                }
                return {
                    title: title,
                    list: list[category]
                };
            }

            return {
                title: this.intl.formatMessage({id: "highlight"}),
                list: list['highlights']
            };
        }
    }

    getPlaceById(placeId) {
        if(this.state.places){
            let list = this.state.places;
            let place = "NOT_FOUND";

            Object.values(list).forEach(categoryList => {
                for(let i=0; i<categoryList.length; i++){
                    if(parseInt(categoryList[i].id) === parseInt(placeId)){
                        place = categoryList[i];
                        break;
                    }
                }
            });

            return place;
        }else{
            return null;
        }
    }

    getEventById(eventId) {
        if(this.state.events){
            let list = this.state.events;

            for(let i=0; i<list.length; i++){
                if(list[i].event_name_normalize === eventId){
                    return list[i];
                }
            }

            return "NOT_FOUND";
        }else{
            return null;
        }
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resize);
    }

    resize() {
        let isMobile = false;
        if( navigator.userAgent.match(/Android/i)
            || navigator.userAgent.match(/webOS/i)
            || navigator.userAgent.match(/iPhone/i)
            || navigator.userAgent.match(/BlackBerry/i)
            || navigator.userAgent.match(/Windows Phone/i)
            ){
            isMobile = true;
        }
        this.setState({
            isMobile: isMobile
        });
    }

    geoLocationSuccess(result) {
        let obj = {
            lat: result.coords.latitude,
            long: result.coords.longitude
        }
        this.setState({
            coords: obj,
            requestGeolocation: false
        });
    }

    geoLocationFailure(error) {
        if(error.code !== error.PERMISSION_DENIED && !this.state.coords && this.state.requestGeolocation) {
            this.requestGeolocation();
        }
    }

    requestGeolocation() {
        if (navigator.geolocation) {
            navigator.geolocation.watchPosition(this.geoLocationSuccess, this.geoLocationFailure, {
                timeout: 5000
            });
            this.setState({
                requestGeolocation: true
            });
        }
    }

    renderScreen(screen) {
        if(this.authResources.getCurrentUser())
        {
            if(!this.state.coords && !this.state.requestGeolocation){
                this.requestGeolocation();
            }
            return screen;
        }
        else
        {
            return (
                <Redirect to="/" />
            );
        }
    }

    renderLandpage(props) {
        if(window.matchMedia("(orientation: landscape)").matches){
            return (
                <LandPageDesktopScreen
                    {...props}
                    mobile={true}
                />
            );
        }
        return (
            <LandPageScreen
                {...props}
                mobile={true}
            />
        );
    }

    render() {
        if(this.state.isMobile) {
            return (
                <LoadingScreen
                    loading={!(this.state.places && this.state.events && this.state.contentLoaded)}
                    bgColor="#f5f5f5"
                    spinnerColor="#6428e5"
                    logoSrc={AppIcon}
                >
                    <BrowserRouter>
                        <Switch>
                            <Redirect from="/logout" to="/" />
                            <Route path="/notfound" component={NotFound} />
                            <Route path="/" exact render={(props) => this.renderLandpage(props)} />
                            <Route path="/login" render={(props) => (
                                <LoginScreen
                                    {...props}
                                    countries={this.state.countries}
                                    loaded={(this.state.places && this.state.events && this.state.contentLoaded)}
                                    userLocalization={this.state.userLocalization}
                                />
                            )} />
                            <Route path="/settings" component={SettingsScreen} />
                            <Route path="/termsConditions" component={TermsConditionsScreen} />
                            <Route path="/about" component={AboutScreen} />
                            <Route path="/map" component={MapScreen} />
                            <Route path="/postcard" component={PostcardScreen} />
                            <Route path="/readPlaceDetails/:id" render={(props) => this.renderScreen((
                                <ReadMoreScreen
                                    {...props}
                                    place={this.getPlaceById(props.match.params.id)}
                                />
                            ))} />
                            <Route path="/placeDetails/:id" render={(props) => this.renderScreen((
                                <PlaceDetailsScreen
                                    {...props}
                                    coords={this.state.coords}
                                    place={this.getPlaceById(props.match.params.id)}
                                    getMorePlaces={this.getMorePlaces}
                                />
                            ))} />
                            <Route path="/shared/placeDetails/:id" render={(props) => (
                                <PlaceDetailsScreen
                                    {...props}
                                    coords={this.state.coords}
                                    shared={true}
                                    placeID={props.match.params.id}
                                    getMorePlaces={this.getMorePlaces}
                                />
                            )} />
                            <Route path="/eventList" render={(props) => this.renderScreen((
                                <EventListScreen
                                    {...props}
                                    events={this.state.events}
                                />
                            ))} />
                            <Route path="/eventDetails/:id" render={(props) => this.renderScreen((
                                <EventDetailsScreen
                                    {...props}
                                    event={this.getEventById(props.match.params.id)}
                                />
                            ))} />
                            <Route path="/shared/eventDetails/:id" render={(props) => (
                                <EventDetailsScreen
                                    {...props}
                                    shared={true}
                                    event={this.getEventById(props.match.params.id)}
                                />
                            )} />
                            <Route path="/placesList/:category" render={(props) => this.renderScreen((
                                <PlacesListScreen
                                    {...props}
                                    coords={this.state.coords}
                                    place={this.getPlaceList(props.match.params.category)}
                                />
                            ))} />
                            <Route path="/home" render={(props) => this.renderScreen((
                                <HomeScreen
                                    {...props}
                                    coords={this.state.coords}
                                    events={this.state.events}
                                    places={this.state.places}
                                    requestGeolocation={this.requestGeolocation}
                                />
                            ))} />
                        </Switch>
                    </BrowserRouter>
                </LoadingScreen>
            );
        }
        else
        {
            return (
                <LandPageDesktopScreen />
            );
        }
    };
}

export default injectIntl(MainScreen);